/*
 *
 * SummaryQuestions actions
 *
 */

import {
  GET_LIST_COUNT_QUESTIONS_WATCHER,
  GET_LIST_COUNT_QUESTIONS_SUCCESS,
  GET_LIST_COUNT_QUESTIONS_FAILED,
} from "./constants"

export function getListCountQuestionsWatcher(payload) {
  return {
    type: GET_LIST_COUNT_QUESTIONS_WATCHER,
    payload,
  }
}

export function getListCountQuestionsSuccess(payload) {
  return {
    type: GET_LIST_COUNT_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getListCountQuestionsFailed() {
  return { type: GET_LIST_COUNT_QUESTIONS_FAILED }
}
